import React, { useState } from "react";

import {
  CognizantColor,
  testScore,
  clockIcon,
  testSheet,
  WhoWeAreImgpowerd,
  IconSkills,
  IconTotal,
  IconAttempted,
  UnAttempted,
  ForReview,
} from "../../Common/CommonImages";

import { Box, Button, LinearProgress, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setValue, setQuestionIndex } from "../../store/Test/action";
import Webcam from "react-webcam";
import { handleSubmit } from "../../utils/Utils.SubmitTest";
import CommonModal from "../../Components/CommonModal/CommonModal";
import {
  handleBackButton,
  handleBeforeUnload,
} from "../../Common/EventHandlers";
const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "user",
};

function Review() {
  const testName = useSelector((state) => state.testReducer.name);
  const remainingTime = useSelector((state) => state.testReducer.newTime);
  const company = useSelector((state) => state.testReducer.company);
  const totalScore = useSelector((state) => state.testReducer.score);
  const totalQue = useSelector((state) => state.testReducer.questions);
  const selectedAnswers = useSelector(
    (state) => state.testReducer.selectedAnswers,
  );

  const cameraStarted = useSelector((state) => state.cameraReducer.isCameraOn);
  const webcamStream = useSelector((state) => state.cameraReducer.webcamStream);

  const testSkills = useSelector((state) => state.testReducer.data);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSubmitModal, setShowSubmitModal] = useState(false);

  // Close submit modal if user exits fullscreen
  React.useEffect(() => {
    const handleFullScreenChange = () => {
      const isFullscreen =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement;

      if (!isFullscreen && showSubmitModal) {
        setShowSubmitModal(false);
      }
    };

    document.addEventListener("fullscreenchange", handleFullScreenChange);
    document.addEventListener("mozfullscreenchange", handleFullScreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullScreenChange);
    document.addEventListener("msfullscreenchange", handleFullScreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullScreenChange,
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullScreenChange,
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullScreenChange,
      );
    };
  }, [showSubmitModal]);

  const handleOverview = () => {
    dispatch(setValue("1"));
    navigate("/overview");
  };

  const handlePrevious = () => {
    navigate("/overview");
  };

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs < 10 ? "0" + hrs : hrs}:${mins < 10 ? "0" + mins : mins}:${
      secs < 10 ? "0" + secs : secs
    }`;
  };

  function getTotalAttemptedQuestions() {
    let totalAttemptedQuestions = 0;
    if (selectedAnswers && typeof selectedAnswers === "object") {
      Object.keys(selectedAnswers).forEach((key) => {
        if (selectedAnswers[key].isAnswered) {
          totalAttemptedQuestions++;
        }
      });
    }
    return totalAttemptedQuestions;
  }

  const answeredPercentage = (getTotalAttemptedQuestions() / totalQue) * 100;

  const questionTypes = [
    "mcqQuestions",
    "programmingQuestions",
    "sqlQuestions",
  ];
  const difficulties = ["easy", "medium", "hard"];

  function getSkillQuestionCount(skill) {
    return questionTypes.reduce((acc, questionType) => {
      if (questionType in skill) {
        return (
          acc +
          difficulties.reduce((acc, difficulty) => {
            return acc + skill[questionType][`${difficulty}Questions`]?.length;
          }, 0)
        );
      }
      return acc;
    }, 0);
  }

  function getSkillWiseAttemptedCount(skill) {
    let attemptedQuestion = 0;

    const skillQuestions = questionTypes.reduce((acc, questionType) => {
      if (questionType in skill) {
        difficulties.forEach((difficulty) => {
          if (skill[questionType][`${difficulty}Questions`]) {
            acc.push(
              ...skill[questionType][`${difficulty}Questions`].map(
                (q) => q._id,
              ),
            );
          }
        });
      }
      return acc;
    }, []);

    skillQuestions.forEach((element) => {
      if (element in selectedAnswers && selectedAnswers[element].isAnswered) {
        attemptedQuestion++;
      }
    });

    return attemptedQuestion;
  }

  function getForReviewCount(skill) {
    let reviewCount = 0;

    const skillQuestions = questionTypes.reduce((acc, questionType) => {
      if (questionType in skill) {
        difficulties.forEach((difficulty) => {
          if (skill[questionType][`${difficulty}Questions`]) {
            acc.push(
              ...skill[questionType][`${difficulty}Questions`].map(
                (q) => q._id,
              ),
            );
          }
        });
      }
      return acc;
    }, []);

    skillQuestions.forEach((element) => {
      if (element in selectedAnswers && selectedAnswers[element].isReviewed) {
        reviewCount++;
      }
    });

    return reviewCount;
  }

  const handleSkillClick = (index) => {
    dispatch(setQuestionIndex(0));
    dispatch(setValue((index + 2).toString()));
    handlePrevious();
  };

  const handleSubmitClick = () => {
    setShowSubmitModal(true);
  };

  const handleConfirmSubmit = () => {
    setShowSubmitModal(false);
    handleTestSubmission();
  };

  const handleCancelSubmit = () => {
    setShowSubmitModal(false);
  };

  const handleTestSubmission = async () => {
    // setIsSubmitting(true);

    try {
      await handleSubmit();
    } catch (error) {
      console.error("Error submitting test:", error);
      // Still redirect even if submission fails
    }

    // Properly remove event listeners using actual function references
    window.removeEventListener("beforeunload", handleBeforeUnload);
    window.removeEventListener("popstate", handleBackButton);
    window.onbeforeunload = null;

    navigate("/feedback");
  };

  return (
    <>
      <Box sx={{ bgcolor: "#f5f5f5", pb: 4 }}>
        {/* Header Section */}
        <Box
          sx={{
            bgcolor: "#fff",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            p: { base: 2, md: 3 },
            position: "relative",
            width: "80%",
            margin: "0 auto",
            mt: 3,
            borderRadius: "10px",
          }}
        >
          <Box
            sx={{
              maxWidth: "1440px",
              mx: "auto",
            }}
          >
            {/* Top Row: Info & Controls */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { base: "column", md: "row" },
                alignItems: { base: "stretch", md: "center" },
                justifyContent: "space-between",
                gap: 3,
                mb: 2,
              }}
            >
              {/* Left: Test Info */}
              <Stack
                direction={{ base: "column", sm: "row" }}
                alignItems={{ base: "flex-start", sm: "center" }}
                spacing={{ base: 2, sm: 3 }}
                divider={
                  <Box
                    sx={{
                      width: "1px",
                      height: "24px",
                      bgcolor: "#ddd",
                      display: { base: "none", sm: "block" },
                    }}
                  />
                }
              >
                <Stack direction="row" alignItems="center" spacing={2}>
                  <img
                    src={testSheet}
                    alt="Test Sheet Icon"
                    style={{ width: "32px", height: "32px" }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      fontSize: { base: "18px", md: "20px" },
                    }}
                  >
                    {testName}
                  </Typography>
                </Stack>

                <Stack direction="row" alignItems="center" spacing={1}>
                  <img src={testScore} alt="" style={{ width: "20px" }} />
                  <Typography variant="body2" fontWeight={600} color="#666">
                    Test score: {totalScore}
                  </Typography>
                </Stack>

                <Stack direction="row" alignItems="center" spacing={1}>
                  <img src={CognizantColor} alt="" style={{ width: "20px" }} />
                  <Typography variant="body2" fontWeight={600} color="#666">
                    {company}
                  </Typography>
                </Stack>
              </Stack>

              {/* Right: Timer, Button, Camera */}
              <Stack
                direction={{ base: "column-reverse", sm: "row" }}
                alignItems={{ base: "stretch", sm: "center" }}
                spacing={3}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent={{ base: "space-between", sm: "flex-end" }}
                  spacing={3}
                >
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <img src={clockIcon} alt="" style={{ width: "20px" }} />
                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: remainingTime < 300 ? "#f44336" : "#333",
                        fontVariantNumeric: "tabular-nums",
                        fontSize: "16px",
                      }}
                    >
                      {formatTime(remainingTime)}
                    </Typography>
                  </Stack>

                  <Button
                    variant="outlined"
                    onClick={handleOverview}
                    sx={{
                      borderColor: "#00C49A",
                      color: "#00C49A",
                      fontWeight: 600,
                      height: "36px",
                      textTransform: "none",
                      "&:hover": {
                        borderColor: "#00A085",
                        bgcolor: "rgba(0, 196, 154, 0.04)",
                      },
                    }}
                  >
                    Overview
                  </Button>
                </Stack>

                {/* Webcam */}
                {cameraStarted && (
                  <Box
                    sx={{
                      width: { base: "140px", md: "160px" },
                      height: { base: "78px", md: "90px" },
                      borderRadius: "8px",
                      overflow: "hidden",
                      bgcolor: "#000",
                      border: "2px solid #00C49A",
                      alignSelf: { base: "center", sm: "auto" },
                    }}
                  >
                    <Webcam
                      audio={false}
                      mirrored={true}
                      screenshotFormat="image/jpeg"
                      videoConstraints={videoConstraints}
                      ref={webcamStream}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                )}
              </Stack>
            </Box>

            {/* Bottom Row: Progress Bar (Full Width) */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <LinearProgress
                variant="determinate"
                value={answeredPercentage}
                sx={{
                  flex: 1,
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: "#E8E9EE",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: "#00C49A",
                  },
                }}
              />
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "#555",
                  minWidth: "45px",
                }}
              >
                {answeredPercentage.toFixed(2)}%
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Main Content - Review Table */}
        <Box
          sx={{
            width: "80%",
            margin: "0 auto",
            mt: { base: 2, md: 3 },
          }}
        >
          <Box
            sx={{
              bgcolor: "#fff",
              borderRadius: "16px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                p: { base: 1.5, md: 2 },
                borderBottom: "1px solid #eee",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: { base: "14px", md: "20px" },
                  color: "#333",
                  width: "100%",
                }}
              >
                Review your test details before submitting
              </Typography>
            </Box>

            <Box
              sx={{
                overflowX: "auto",
                padding: "10px",
                width: "80%",
                margin: "0 auto",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  minWidth: "600px",
                  margin: "0 auto", // Ensure table is centered if width < 100%
                  border: "1px solid #e0e0e0", // Outer border
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f8f9fa" }}>
                    {[
                      { icon: IconSkills, label: "Skill" },
                      { icon: IconTotal, label: "Total" },
                      { icon: IconAttempted, label: "Attempted" },
                      { icon: UnAttempted, label: "Unattempted" },
                      { icon: ForReview, label: "Review" },
                    ].map((col, idx) => (
                      <th
                        key={idx}
                        style={{
                          padding: "16px",
                          textAlign: "center",
                          justifyContent: "center",
                          borderBottom: "2px solid #e0e0e0",
                          borderRight: "1px solid #e0e0e0", // Vertical divider
                          color: "#666",
                          fontWeight: 600,
                        }}
                      >
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                          spacing={1}
                        >
                          <img
                            src={col.icon}
                            alt=""
                            style={{ width: "20px" }}
                          />
                          <span>{col.label}</span>
                        </Stack>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {testSkills?.map((skill, index) => (
                    <tr
                      key={index}
                      onClick={() => handleSkillClick(index)}
                      style={{
                        cursor: "pointer",

                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#f5fdfb")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "transparent")
                      }
                    >
                      <th
                        style={{
                          padding: "16px",
                          textAlign: "center",
                          borderBottom: "1px solid #e0e0e0",
                          borderRight: "1px solid #e0e0e0", // Vertical divider
                          color: "#333",
                          fontWeight: 600,
                          textTransform: "capitalize",
                        }}
                      >
                        {skill?.skill?.name}
                      </th>
                      {[
                        getSkillQuestionCount(skill),
                        getSkillWiseAttemptedCount(skill),
                        getSkillQuestionCount(skill) -
                          getSkillWiseAttemptedCount(skill),
                        getForReviewCount(skill),
                      ].map((val, i) => (
                        <td
                          key={i}
                          style={{
                            padding: "16px",
                            textAlign: "center",
                            borderBottom: "1px solid #e0e0e0",
                            borderRight: "1px solid #e0e0e0", // Vertical divider
                            color: "#555",
                            fontWeight: 500,
                          }}
                        >
                          {val}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>

            {/* Footer Buttons */}
            <Box
              sx={{
                p: 2,
                display: "flex",
                flexDirection: { base: "column-reverse", sm: "row" },
                justifyContent: "space-between",
                alignItems: "center",
                borderTop: "1px solid #e0e0e0",
                gap: 2,
                bgcolor: "#fcfcfc",
              }}
            >
              <Box sx={{ display: "block" }}>
                <img
                  src={WhoWeAreImgpowerd}
                  alt="Powered by"
                  style={{ height: "24px", width: "200px" }}
                />
              </Box>

              <Stack
                direction={{ base: "column", sm: "row" }}
                spacing={2}
                sx={{ width: { base: "100%", sm: "auto" } }}
              >
                <Button
                  variant="outlined"
                  onClick={handlePrevious}
                  sx={{
                    width: { base: "100%", sm: "auto" },
                    borderColor: "#ff6812",
                    color: "#ff6812",
                    textTransform: "none",
                    fontWeight: 600,
                    borderRadius: "8px",
                    height: "40px",
                    "&:hover": {
                      borderColor: "#ff6812",
                      bgcolor: "#fff",
                    },
                  }}
                >
                  Previous
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSubmitClick}
                  sx={{
                    width: { base: "100%", sm: "auto" },
                    bgcolor: "#00C49A",
                    color: "#fff",
                    textTransform: "none",
                    fontWeight: 600,
                    borderRadius: "8px",
                    height: "40px",
                    boxShadow: "0 4px 12px rgba(0, 196, 154, 0.3)",
                    "&:hover": {
                      bgcolor: "#00A085",
                      boxShadow: "0 6px 16px rgba(0, 196, 154, 0.4)",
                    },
                  }}
                >
                  Submit Test
                </Button>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Submit Confirmation Modal */}
      <CommonModal
        open={showSubmitModal}
        handleClose={handleCancelSubmit}
        title="Complete Assessment"
        onSubmit={handleConfirmSubmit}
        cancelButtonName="Cancel"
        sendButtonName="Finish Assessment"
        type="warning"
        icon="/assets/alert-orange.svg"
        width="500px"
      >
        <Typography sx={{ fontSize: "14px", color: "#666", lineHeight: "1.5" }}>
          Are you ready to complete your assessment? You will need to provide
          feedback to finish the process.
        </Typography>
      </CommonModal>
    </>
  );
}

export default Review;
